<template>
    <div class="manifestos-lista">
        <section class="content">
            <lista @lista="atualizaLista" @carregado="carregado = true" ref="lista">
                <lista-topo @limpaBusca="limpaBuscaAvancada">
                    <template #buscaPeriodo />
                    <template #buscaAvancada="{ lojas }">
                        <busca-avancada :buscaAvancada="buscaAvancada" :lojas="lojas" :data="data" />
                    </template>
                    <template #botoes>
                        <b-button
                            id="botao-adicionar"
                            @click="abreAdicionar()"
                            variant="success"
                            size="md"
                            class="mr-1 inline-block"
                        >
                            <i class="fa fa-plus-circle" />
                            Adicionar
                        </b-button>
                        <b-dropdown id="botao-mais-acoes" ref="botao-mais-acoes" variant="primary" @hide="manterDropdownAberto" @show="campos[0].visible = true">
                            <template #button-content>
                                <span>
                                    <i class="fa fa-gears" />
                                    Mais ações
                                </span>
                            </template>
                            <b-dropdown-item-button @click="abreImportarXml()">
                                <i class="fa icon-font icon-file-xml mr-2" />
                                Importar XML's
                            </b-dropdown-item-button>
                            <b-dropdown-item-button @click="exportarXml()">
                                <i class="mr-1 fa fa-cloud-download" />
                                Exportar XML's
                            </b-dropdown-item-button>
                            <b-dropdown-item-button>
                                <a :href="`${$urlBase}/configuracoes/certificado_digital`" class="certificado-digital">
                                    <i class="mr-1 icon-certificatethree" />
                                    Certificado digital
                                </a>
                            </b-dropdown-item-button>
                            <b-dropdown-item-button @click.prevent="excluirSelecionados">
                                <i class="mr-1 fa icon-remove margin-right-10px" />
                                Excluir manifestos
                            </b-dropdown-item-button>
                        </b-dropdown>
                    </template>
                </lista-topo>
                <lista-itens v-if="manifestos.length" id="itens" :campos="camposVisiveis" :itens="manifestos">
                    <template #head(selecionado)>
                        <div class="text-center pl-2">
                            <b-form-checkbox :checked="false" v-model="chkSelecionaTodos" @change="selecionaTodos" />
                        </div>
                    </template>
                    <template #cell(selecionado)="data">
                        <div class="text-center pl-2">
                            <b-form-checkbox :checked="data.item.Manifesto.selecionado" @change="selecionaRegistro(data.index)" />
                        </div>
                    </template>
                    <template #cell(Manifesto.situacao)="data">
                        <div>
                            <b-badge
                                v-b-tooltip.hover
                                :title="data.item.Manifesto.situacao == 2 || data.item.Manifesto.situacao == 4 ? data.item.Manifesto.xMotivo : ''"
                                :variant="data.item.Manifesto.classe_situacao"
                                >{{ data.item.Manifesto.nome_situacao }}</b-badge
                            >
                        </div>
                    </template>
                    <template #cell(Manifesto.situacao_email)="data">
                        <div>
                            <b-badge :variant="data.item.Manifesto.classe_situacao_email">{{ data.item.Manifesto.nome_situacao_email }}</b-badge>
                        </div>
                    </template>
                    <template #cell(acoes)="data">
                        <div class="coluna-acoes4">
                            <b-button
                                v-b-tooltip.hover
                                title="Visualizar"
                                variant="info"
                                size="xs"
                                @click="abreVisualizar(data.item.Manifesto.id)"
                                class="mr-1"
                            >
                                <i class="glyphicon glyphicon-search" />
                            </b-button>
                            <b-button
                                v-b-tooltip.hover
                                variant="warning"
                                title="Editar"
                                size="xs"
                                @click="abreEditar(data.item.Manifesto.id)"
                                class="mr-1"
                            >
                                <i class="glyphicon glyphicon-edit" />
                            </b-button>
                            <b-button v-b-tooltip.hover title="Deletar" variant="danger" size="xs" @click.prevent="deleta(data.item)" class="botao-excluir">
                                <i class="glyphicon glyphicon-remove" />
                            </b-button>
                            <b-dropdown v-b-tooltip.hover title="Mais ações" class="ml-1" size="xs" variant="success" right boundary="window">
                                <b-dropdown-item
                                    v-if="data.item.Manifesto.nome_situacao == 'Em aberto' || data.item.Manifesto.nome_situacao == 'Reprovada'"
                                    class="mais_acoes"
                                    @click.prevent="emitirManifesto(data.item.Manifesto)"
                                >
                                    <i class="text-success fa icon-sync mr-2" />
                                    Emitir manifesto
                                </b-dropdown-item>
                                <b-dropdown-item class="mais_acoes" target="_blank" :href="`${$urlBase}/damdfe/${data.item.Manifesto.hash}`">
                                    <i class="text-primary fa fa-print mr-2" />
                                    Imprimir DAMDFE
                                </b-dropdown-item>                                
                                <b-dropdown-item class="mais_acoes" @click.prevent="enviarWhatsapp(data.item.Manifesto.id)">
                                    <i class="text-success fa icon-whatsapp mr-2" />
                                    Compartilhar
                                </b-dropdown-item>
                                <b-dropdown-item
                                    class="mais_acoes"
                                    @click.prevent="baixarXml(data.item.Manifesto.id)"
                                >
                                    <i class="text-muted fa icon-font icon-file-xml mr-2" />
                                    Baixar XML
                                </b-dropdown-item>
                                <b-dropdown-item
                                    v-if="data.item.Manifesto.nome_situacao == 'Aprovada' || data.item.Manifesto.nome_situacao == 'Encerrado'"
                                    class="mais_acoes"
                                    @click.prevent="enviarEmail(data.item.Manifesto.id)"
                                >
                                    <i class="text-warning fa icon-envelope mr-2" />
                                    Enviar por email
                                </b-dropdown-item>
                                <b-dropdown-item
                                    v-if="data.item.Manifesto.nome_situacao == 'Aprovada'"
                                    class="mais_acoes"
                                    @click.prevent="abreModalCancelar(data.item.Manifesto)"
                                >
                                    <i class="text-danger fa fa-ban mr-2" />
                                    Cancelar manifesto
                                </b-dropdown-item>
                                <b-dropdown-item
                                    v-if="data.item.Manifesto.nome_situacao == 'Aprovada'"
                                    class="mais_acoes"
                                    @click.prevent="encerrarManifesto(data.item.Manifesto)"
                                >
                                    <i class="text-success fa fa-check mr-2" />
                                    Encerrar
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </template>
                </lista-itens>
                <lista-vazia
                    v-if="!manifestos.length && !$route.query.data_inicio && !$route.query.situacaoBuscaAvancada"
                    :icone="listaVazia.icone"
                    :titulo="listaVazia.titulo"
                    :descricao="listaVazia.descricao"
                    :botoes="listaVazia.botoes"
                    :tituloLista="listaVazia.tituloLista"
                    :lista="listaVazia.lista"
                    :possuiVideoTutorial="false"
                    :ajuda="false"
                />
                <b-row v-if="!manifestos.length && ($route.query.data_inicio || $route.query.situacaoBuscaAvancada)" class="no-result">
                    <b-col sm="12">
                        <i class="glyphicon glyphicon-warning-sign" />
                    </b-col>
                    <b-col sm="12">
                        <h3>Nenhum Manifesto foi encontrado!</h3>
                    </b-col>
                </b-row>
            </lista>
        </section>

        <b-modal title="Cancelar MDF-e" hide-footer id="modalCancelarManifesto">
            <div>
                <b-form-group
                    label="Motivo do cancelamento"
                    label-for="motivo"
                    class="required"
                    :invalid-feedback="errors.first('motivo')"
                    :state="!errors.has('motivo')"
                >
                    <b-form-textarea
                        v-model="formCancelamento.motivo"
                        autocomplete="off"
                        name="motivo"
                        rows="4"
                        v-validate="'required|min:15'"
                        :class="[
                            {
                                error: errors.first('motivo')
                            }
                        ]"
                    />
                </b-form-group>
                <div class="mt-2">
                    <b-button @click.prevent="cancelarManifesto()" variant="success" class="mr-2">
                        <i class="glyphicon glyphicon-ok"></i>
                        Concluir
                    </b-button>
                    <b-button variant="danger" @click.prevent="fechar()">
                        <i class="glyphicon glyphicon-remove"></i>
                        Fechar
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
/* eslint-disable no-useless-escape */
import Lista from '@/shared/common/mixins/Lista'
import BuscaAvancada from './BuscaAvancada.vue'
import MaisAcoes from '@/shared/common/mixins/MaisAcoes'
import { downloadBase64 } from '@/shared/common/functions/retornos'
import ComunicacaoAssefaz from '../mixins/ComunicacaoAssefaz'

export default {
    $_veeValidate: {
        validator: 'new'
    },
    name: 'ManifestoLista',
    mixins: [MaisAcoes, Lista, ComunicacaoAssefaz],
    components: {
        BuscaAvancada
    },
    computed: {
        camposVisiveis() {
            return this.campos.filter((field) => field.visible)
        }
    },
    data() {
        return {
            permissaoAdicionar: true,
            permissaoCompartilharWhatsapp: true,
            permissaoEditar: true,
            permissaoEnviarLinkEmail: true,
            permissaoExportarXml: true,
            permissaoImportarXml: true,
            permissaoVisualizar: true,
            permissaoBaixarXml: true,
            permissaoExcluir: true,
            permissaoExcluirMassa: true,
            uflist: {
                'AC': 12,
                'AL': 27,
                'AM': 13,
                'AN': 91,
                'AP': 16,
                'BA': 29,
                'CE': 23,
                'DF': 53,
                'ES': 32,
                'GO': 52,
                'MA': 21,
                'MG': 31,
                'MS': 50,
                'MT': 51,
                'PA': 15,
                'PB': 25,
                'PE': 26,
                'PI': 22,
                'PR': 41,
                'RJ': 33,
                'RN': 24,
                'RO': 11,
                'RR': 14,
                'RS': 43,
                'SC': 42,
                'SE': 28,
                'SP': 35,
                'TO': 17,
                'SVCAN': 92,
                'SVCRS': 93,
                'EX': 99
            },
            formCancelamento: {
                id: '',
                motivo: '',
                autorizacao: ''
            },
            urlEnvioXml: '/manifestos', //usado pelo mix [ComunicacaoAssefaz] para assinatura do xml
            carregado: false,
            data: {},
            buscaPeriodo: {},
            buscaAvancada: {
                loja: '',
                ide_nMDF: '',
                ide_serie: '',
                data_inicio: '',
                data_fim: '',
                situacao: '',
                veicTracao_placa: '',
                condutor: '',
                contratante: '',
                municipio_carregamento: '',
                municipio_descarregamento: '',
                uf_carregamento: '',
                uf_decarregamento: '',
                seguradora: ''
            },
            situacoes: [],
            manifestos: [],
            campos: [
                {
                    key: 'selecionado',
                    label: '',
                    visible: false,
                    thStyle: { width: '15px', textAlign: 'center' }
                },
                {
                    key: 'Manifesto.ide_nMDF',
                    label: 'Nº',
                    sortable: true,
                    visible: true
                },
                {
                    key: 'Manifesto.ide_serie',
                    label: 'Série',
                    sortable: true,
                    visible: true
                },
                {
                    key: 'Manifesto.ide_dataEmi',
                    label: 'Data',
                    sortable: true,
                    visible: true
                },
                {
                    key: 'Manifesto.ide_UFIni',
                    label: 'UF de carregamento',
                    sortable: true,
                    visible: true
                },
                {
                    key: 'Manifesto.ide_UFFim',
                    label: 'UF de descarregamento',
                    sortable: true,
                    visible: true
                },
                {
                    key: 'Manifesto.situacao',
                    label: 'Situação',
                    class: 'd-none d-sm-table-cell text-center',
                    sortable: true,
                    visible: true
                },
                {
                    key: 'Manifesto.situacao_email',
                    label: 'Email',
                    sortable: true,
                    visible: true,
                    class: 'd-none d-sm-table-cell text-center'
                },
                {
                    key: 'Manifesto.nome_loja',
                    label: 'Loja',
                    sortable: true,
                    visible: true
                },
                {
                    key: 'acoes',
                    label: 'Ações',
                    sortable: false,
                    class: 'text-center',
                    thStyle: { width: '140px' },
                    visible: true
                }
            ],
            chkSelecionaTodos: false,
            listaVazia: {
                icone: 'fa-road',
                titulo: 'Manifestos',
                descricao:
                    'Manifestos são itens que serão utilizados na sua empresa. Estes manifestos podem ser distribuídos entre os setores e funcionários. Você definirá os setores, funcionário responsável, situação, número de série e número de patrimônio de cada Manifesto.',
                botoes: [
                    {
                        variant: 'success',
                        link: `${this.$urlBase}/manifestos/adicionar`,
                        icone: 'fa-plus-circle',
                        texto: 'Adicionar <span class="d-none d-md-inline-flex">meu primeiro&nbsp;</span>Manifesto'
                    },
                    {
                        variant: 'primary',
                        link: `${this.$urlBase}/manifestos/importar_xml`,
                        icone: 'fa-cloud-upload',
                        class: 'd-none d-md-inline-flex',
                        texto: 'Importar meus manifestos'
                    }
                ],
                tituloLista: 'Adicionando manifestos você vai conseguir:',
                lista: [
                    'Emitir manifetos',
                    'Armazenar os XML dos manifestos',
                    'Enviar a DAMDFE para os clientes e fornecedores via e-mail',
                    'Imprimir a DAMDFE',
                    'Baixar os XMLs dos manifestos',
                    'Obter histórico de manifestos',
                    'Cancelar manifestos',
                    'Encerrar manifestos',
                    'E muito mais...'
                ]
            }
        }
    },
    mounted(){
        
        
    },
    methods: {
        atualizaLista(retorno) {
            if (retorno.status == 'success') {                
                this.data = retorno.data
                this.buscaAvancada = retorno.data.buscaAvancada

                this.buscaAvancada.loja =  this.buscaAvancada.loja == '' ? this.$usuarioLogado.Loja.id : this.buscaAvancada.loja;

                this.manifestos = retorno.data.manifestos.map((item) => ({
                    Manifesto: { ...item.Manifesto, selecionado: false }
                }))

                if(!this.buscaAvancada['situacaoBuscaAvancada']) {
                    this.buscaAvancada.loja = this.$usuarioLogado.Loja.id;
                }

                this.permissaoAdicionar = retorno.data.permissaoAdicionar;
                this.permissaoCompartilharWhatsapp = retorno.data.permissaoCompartilharWhatsapp;
                this.permissaoEditar = retorno.data.permissaoEditar;
                this.permissaoEnviarLinkEmail = retorno.data.permissaoEnviarLinkEmail;
                this.permissaoExportarXml = retorno.data.permissaoExportarXml;
                this.permissaoImportarXml = retorno.data.permissaoImportarXml;
                this.permissaoVisualizar = retorno.data.permissaoVisualizar;
                this.permissaoBaixarXml = retorno.data.permissaoBaixarXml;
                this.permissaoExcluir = retorno.data.permissaoExcluir;
                this.permissaoExcluirMassa = retorno.data.permissaoExcluirMassa;

                this.campos[0].visible = false
                this.chkSelecionaTodos = false

            }else{
                
                this.$notify.error(retorno.message)
                this.$router.push(this.$route.query.retorno || `${this.$urlBase}/inicio`)
            }
            
        },
        abreAdicionar(){

            if(this.permissaoAdicionar === 0){
                this.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            this.$router.push({
                path: `${this.$urlBase}/manifestos/adicionar?retorno=${this.$refs.lista.urlRetornoFormatada}`
            }).catch(() => {});        

        },
        abreEditar(id){

            if(this.permissaoEditar === 0){
                this.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            this.$router.push({
                path: `${this.$urlBase}/manifestos/editar/${id}?retorno=${this.$refs.lista.urlRetornoFormatada}`
            }).catch(() => {});        

        },   
        abreVisualizar(id){

            if(this.permissaoVisualizar === 0){
                this.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            this.$router.push({
                path: `${this.$urlBase}/manifestos/visualizar/${id}`
            }).catch(() => {});
           
        },
        abreImportarXml(){

            if(this.permissaoImportarXml === 0){
                this.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            this.$router.push({
                path: `${this.$urlBase}/manifestos/importar_xml`
            }).catch(() => {});  
            
        },  
        fechar() {
            this.$bvModal.hide('modalCancelarManifesto')
        },
        async abreModalCancelar(manifesto) {
            this.formCancelamento.id = ''
            this.formCancelamento.motivo = ''

            const retorno = await this.$api.get(`${this.$urlBase}/manifestos/cancelar/${manifesto.id}`)

            if (retorno.status == 'success') {
                this.formCancelamento.id = manifesto.id
                this.formCancelamento.autorizacao = retorno.data.autorizacao
                this.$bvModal.show('modalCancelarManifesto')
            } else {
                this.$dialog.error(retorno.message)
            }
        },
        async cancelarManifestoA1() {
            this.mensagemProcessamento('Enviando para SEFAZ...')
            const retornoCancelar = await this.$api.post(`${this.$urlBase}/manifestos/cancelar/${this.formCancelamento.id}`, {
                autorizacao: this.formCancelamento.autorizacao,
                motivo: this.formCancelamento.motivo
            })

            if (retornoCancelar.status == 'success') {
                this.mensagemProcessamento('Atualizando status do manifesto...')

                const retorno = await this.$api.post(`${this.$urlBase}/manifestos/atualizar_situacao/${this.formCancelamento.id}`, {
                    situacao: 4,
                    motivo: this.formCancelamento.motivo
                })

                if (retorno.status == 'success') {
                    this.$notify.success(retorno.message)
                    this.$bvModal.hide('modalCancelarManifesto')
                    this.$refs.lista.atualiza()
                    return true
                } else {
                    this.removeMensagemProcessamento()
                    this.$dialog.error(retorno.message)
                    return false
                }
            } else {
                this.removeMensagemProcessamento()
                this.$dialog.error(retornoCancelar.message)
            }
        },

        async cancelarManifestoA3() {
            this.mensagemProcessamento('Enviando para SEFAZ...')
            const query = await this.$api.get(`${this.$urlBase}/manifestos/visualizar/${this.formCancelamento.id}`)
            const manifesto = query['data']['manifesto']['Manifesto']
            const loja = query['data']['manifesto']['Loja']

            const sigla = loja.cnpj.length == 11 ? 'CPF' : 'CNPJ'
            let documentoEmitente = sigla == 'CNPJ' ? loja.cnpj : loja.cpf
            documentoEmitente = documentoEmitente.replace(/\./g, "")
            documentoEmitente = documentoEmitente.replace('/', "")
            documentoEmitente = documentoEmitente.replace('-', "")
            const dhEvento = `${this.$moment().format()}`
            const chMDFe = manifesto.chMDFe
            const tpEvento = '110111'
            const sSeqEvento = '01'
            const eventId = `ID${tpEvento}${chMDFe}${sSeqEvento}`
            const cOrgao = this.uflist[loja.estado]
            const tpAmb = manifesto.ide_tpAmb

            const urlMDFe = tpAmb == 2 ? 'https://mdfe-homologacao.svrs.rs.gov.br' : 'https://mdfe.svrs.rs.gov.br'

            let request = `<eventoMDFe xmlns="http://www.portalfiscal.inf.br/mdfe" versao="3.00">`
            request += `<infEvento Id="${eventId}">`
            request += `<cOrgao>${cOrgao}</cOrgao>`
            request += `<tpAmb>${tpAmb}</tpAmb>`
            request += `<${sigla}>${documentoEmitente}</${sigla}>`
            request += `<chMDFe>${chMDFe}</chMDFe>`
            request += `<dhEvento>${dhEvento}</dhEvento>`
            request += `<tpEvento>${tpEvento}</tpEvento>`
            request += `<nSeqEvento>${sSeqEvento}</nSeqEvento>`
            request += `<detEvento versaoEvento="3.00">`

            const nProt = manifesto.nProt

            request += `<evCancMDFe>`
            request += `<descEvento>Cancelamento</descEvento>`
            request += `<nProt>${nProt}</nProt>`
            request += `<xJust>${this.formCancelamento.motivo.trim()}</xJust>`
            request += `</evCancMDFe>`

            request += `</detEvento>`
            request += `</infEvento>`
            request += `</eventoMDFe>`

            const retornoPostCancelar = await this.api(`${this.$urlBase}/manifestos/cancelar`, {
                xml: request,
                cUF:  manifesto.ide_cUF,
                servicos: {
                    MdfeRecepcaoEvento: {
                        operation: 'MDFeRecepcaoEvento',
                        URL: `${urlMDFe}/ws/MDFeRecepcaoEvento/MDFeRecepcaoEvento.asmx?op=mdfeRecepcaoEvento`,
                        version: '3.00'
                    }
                }
            })


            if (retornoPostCancelar.sucesso) {
                this.mensagemProcessamento('Atualizando status do manifesto...')

                await this.$api.post(`${this.$urlBase}/manifestos/adiciona_protocolo_cancelamento/${this.formCancelamento.id}`, {
                    xml: retornoPostCancelar.retorno.xmlRetorno
                })

                const retorno = await this.$api.post(`${this.$urlBase}/manifestos/atualizar_situacao/${this.formCancelamento.id}`, {
                    situacao: 4,
                    motivo: this.formCancelamento.motivo,
                    xml: retornoPostCancelar.retorno.xmlRetorno
                })

                if (retorno.status == 'success') {
                    this.$bvModal.hide('modalCancelarManifesto')
                    this.$notify.success(retorno.message)
                    this.$refs.lista.atualiza()
                } else {
                    this.removeMensagemProcessamento()
                    this.$dialog.error(retorno.message)
                    return false
                }
            } else {
                this.removeMensagemProcessamento()
                this.$dialog.error(retornoPostCancelar.message)
            }
        },

        async cancelarManifesto() {
            const validado = await this.$validator.validateAll()
            if (!validado) {
                return false
            }
            if (this.$usuarioLogado.LojaConfiguracoes.modelo_certificado_digital == '1') {
                await this.cancelarManifestoA1()
            } else {
                await this.cancelarManifestoA3()
            }
        },

        async encerrarManifestoA1(manifesto) {
            const id = manifesto.id
            this.mensagemProcessamento('Enviando para SEFAZ...')
            const retornoGetEncerrar = await this.$api.get(`${this.$urlBase}/manifestos/encerrar/${id}`)
            if (retornoGetEncerrar.status == 'success') {
                const retornoPostEncerrar = await this.api(`${this.$urlBase}/manifestos/encerrar/${id}`, {
                    autorizacao: retornoGetEncerrar.data.autorizacao
                })

                if (retornoPostEncerrar.status == 'success') {
                    this.mensagemProcessamento('Atualizando status do manifesto...')

                    const retorno = await this.$api.post(`${this.$urlBase}/manifestos/atualizar_situacao/${id}`, {
                        situacao: 3
                    })

                    if (retorno.status == 'success') {
                        this.$notify.success(retorno.message)
                        this.$refs.lista.atualiza()
                    } else {
                        this.removeMensagemProcessamento()
                        this.$dialog.error(retorno.message)
                        return false
                    }
                } else {
                    this.removeMensagemProcessamento()
                    this.$dialog.error(retornoPostEncerrar.message)
                }
            } else {
                this.removeMensagemProcessamento()
                this.$dialog.error(retornoGetEncerrar.message)
            }
        },

        async encerrarManifestoA3(id) {
            this.mensagemProcessamento('Enviando para SEFAZ...')

            const query = await this.$api.get(`${this.$urlBase}/manifestos/visualizar/${id}`)
            const manifesto = query['data']['manifesto']['Manifesto']
            const loja = query['data']['manifesto']['Loja']

            const sigla = loja.cnpj.length == 11 ? 'CPF' : 'CNPJ'
            let documentoEmitente = sigla == 'CNPJ' ? loja.cnpj : loja.cpf
            documentoEmitente = documentoEmitente.replace(/\./g, "")
            documentoEmitente = documentoEmitente.replace('/', "")
            documentoEmitente = documentoEmitente.replace('-', "")
            const dhEvento = `${this.$moment().format()}`
            const chMDFe = manifesto.chMDFe
            const tpEvento = '110112'
            const sSeqEvento = '01'
            const eventId = `ID${tpEvento}${chMDFe}${sSeqEvento}`
            const cOrgao = this.uflist[loja.estado]
            const tpAmb = manifesto.ide_tpAmb
            const urlMDFe = tpAmb == 2 ? 'https://mdfe-homologacao.svrs.rs.gov.br' : 'https://mdfe.svrs.rs.gov.br'

            let request = `<eventoMDFe xmlns=\"http://www.portalfiscal.inf.br/mdfe\" versao=\"3.00\">`
            request += `<infEvento Id=\"${eventId}\">`
            request += `<cOrgao>${cOrgao}</cOrgao>`
            request += `<tpAmb>${tpAmb}</tpAmb>`
            request += `<${sigla}>${documentoEmitente}</${sigla}>`
            request += `<chMDFe>${chMDFe}</chMDFe>`
            request += `<dhEvento>${dhEvento}</dhEvento>`
            request += `<tpEvento>${tpEvento}</tpEvento>`
            request += `<nSeqEvento>${sSeqEvento}</nSeqEvento>`
            request += `<detEvento versaoEvento=\"3.00\">`

            const dtEnc = this.$moment().format('YYYY-MM-DD')
            const cUF =  manifesto.ide_cUF
            const cMun = manifesto.emit_cMun
            const nProt = manifesto.nProt

            request += `<evEncMDFe>`
            request += `<descEvento>Encerramento</descEvento>`
            request += `<nProt>${nProt}</nProt>`
            request += `<dtEnc>${dtEnc}</dtEnc>`
            request += `<cUF>${cUF}</cUF>`
            request += `<cMun>${cMun}</cMun>`
            request += `</evEncMDFe>`

            request += `</detEvento>`
            request += `</infEvento>`
            request += `</eventoMDFe>`

            const retornoPostEncerrar = await this.api(`${this.$urlBase}/manifestos/encerrar`, {
                xml: request,
                cUF: cUF,
                servicos: {
                    MdfeRecepcaoEvento: {
                        operation: 'MDFeRecepcaoEvento',
                        URL: `${urlMDFe}/ws/MDFeRecepcaoEvento/MDFeRecepcaoEvento.asmx?op=mdfeRecepcaoEvento`,
                        version: "3.00"
                    }
                }
            })

            if (retornoPostEncerrar.sucesso) {
                this.mensagemProcessamento('Atualizando status do manifesto...')

                await this.$api.post(`${this.$urlBase}/manifestos/adiciona_protocolo_encerramento/${id}`, {
                    xml: retornoPostEncerrar.retorno.xmlRetorno
                })

                const retorno = await this.$api.post(`${this.$urlBase}/manifestos/atualizar_situacao/${id}`, {
                    situacao: 3
                })

                if (retorno.status == 'success') {
                    this.$notify.success(retorno.message)
                    this.$refs.lista.atualiza()
                } else {
                    this.removeMensagemProcessamento()
                    this.$dialog.error(retorno.message)
                    return false
                }
            } else {
                this.removeMensagemProcessamento()
                this.$dialog.error(retornoPostEncerrar.message)
            }
        },

        async encerrarManifesto(manifesto) {
            const confirmacao = await this.$dialog.confirm(`Deseja realmente encerrar este manifesto?`, {
                icon: 'text-success fa fa-share-square-o'
            })
            if (confirmacao) {
                if (this.$usuarioLogado.LojaConfiguracoes.modelo_certificado_digital == '1') {
                    await this.encerrarManifestoA1(manifesto)
                } else {
                    await this.encerrarManifestoA3(manifesto.id)
                }
            } else {
                return false
            }
        },
        async emitirManifesto(manifesto) {
            const confirmacao = await this.$dialog.confirm(`Deseja realmente enviar este manifesto?`, {
                icon: 'text-success fa fa-share-square-o'
            })
            if (confirmacao) {
                const id = manifesto.id
                await this.enviar(id)

                this.$refs.lista.atualiza()
            } else {
                return false
            }
        },
        async enviar(id) {
            // VALIDA CERTIFICADO DIGITAL
            const executaAplicacao = await this.executaAplicacao()
            if (!executaAplicacao) {
                return false
            }
            // MONTA XML
            const envio = await this.montaXml(id)
            if (!envio.sucesso) {
                return false
            }
            // ASSINA XML
            const assinaXml = await this.assinarXml({
                autorizacao: envio.autorizacao,
                xml: envio.xml,
                serie: envio.serie,
                ide_mod: 58
            })
            if (!assinaXml.sucesso) {
                return false
            }
            // AUTORIZA ENVIO
            const xml = assinaXml.xmlAssinado || assinaXml.xml //quando A3
            const autorizaEnvio = await this.autorizaEnvio(id, envio, xml)
            if (autorizaEnvio !== false || autorizaEnvio.sucesso) {
                //SALVA XML ASSINADO
                await this.salvaXmlAutorizado(id, xml, autorizaEnvio)
            }
        },
        async salvaXmlAutorizado(id, xmlAssinado, autorizaEnvio) {
            let payload = {
                id: id,
                protocolo: autorizaEnvio.data?.protocolo || autorizaEnvio.protocolo,
                xml_assinado: xmlAssinado
            }
            this.mensagemProcessamento('Atualizando status do manifesto...')
            const retorno = await this.$api.post(this.$urlBase + '/manifestos/salva_xml_autorizado', payload)
            this.removeMensagemProcessamento()

            if (retorno.status == 'success') {
                this.$notify.success('Manifesto emitido com sucesso!')
            } else {
                let errorMsg = retorno.devTools && retorno.devTools.error ? retorno.devTools.error : (retorno.mensagem ? retorno.mensagem : retorno.message)
                this.$dialog.error(errorMsg)
            }
        },
        async montaXml(id) {
            this.mensagemProcessamento('Processando manifesto...')
            const retorno = await this.$api.get(this.$urlBase + '/manifestos/envia/' + id)
            if (!retorno.sucesso || retorno.status == 'error') {
                this.removeMensagemProcessamento()
                let errorMsg = retorno.devTools && retorno.devTools.error ? retorno.devTools.error : retorno.mensagem
                this.$dialog.error(errorMsg)
            }
            return retorno
        },
        async autorizaEnvio(id, envio, xmlAssinado) {
            this.mensagemProcessamento('Enviando para SEFAZ...')
            const retorno = await this.api(`${this.$urlBase}/manifestos/autoriza_envio`, {
                id: id,
                xmlAssinado: xmlAssinado,
                autorizacao: envio.autorizacao,
                ambiente: envio.ambiente,
                cUF: envio.cUF,
                // somente para A3
                servicos: {
                    MdfeAutorizaEnvio: {
                        operation: 'MDFeRecepcao',
                        version: '3.00'
                    }
                }
            })
            if (retorno.status == 'success' || retorno.sucesso) {
                return retorno
            } else {
                this.removeMensagemProcessamento()

                this.$dialog.error(retorno.mensagem)

                await this.$api.post(`${this.$urlBase}/manifestos/atualizar_situacao/${id}`, {
                    situacao: 2,
                    motivo: retorno.mensagem
                })
                this.$refs.lista.atualiza()
                return false
            }
        },        
        async deleta(item) {

            if(this.permissaoExcluir === 0){
                this.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            const deletar = await this.$dialog.delete(`Deseja realmente excluir o Manifesto <span class="font-weight-bold">${item.Manifesto.ide_nMDF}</span>?`)
            if (deletar) {
                const retorno = await this.$api.delete(`${this.$urlBase}/manifestos/deletar/${item.Manifesto.id}`)
                if (retorno.status == 'success') {
                    this.$notify.success(retorno.message)
                    this.$refs.lista.atualiza()
                } else {
                    this.$dialog.error(retorno.message)
                }
            }
        },
        selecionaRegistro(index) {
            this.manifestos[index].Manifesto.selecionado = !this.manifestos[index].Manifesto.selecionado
        },
        selecionaTodos() {
            for (let j = 0; j < this.manifestos.length; j++) {
                this.manifestos[j].Manifesto.selecionado = this.chkSelecionaTodos
            }
        },
        async exportar() {

            let qtdmanifestosSelecionados = 0
            let formData = new FormData()
            for (let i = 0; i < this.manifestos.length; i++) {
                if (this.manifestos[i].Manifesto.selecionado) {
                    qtdmanifestosSelecionados++
                    formData.append('manifestos[]', this.manifestos[i].Manifesto.id)
                }
            }
            if (qtdmanifestosSelecionados == 0) {
                this.$dialog.error('Você deve selecionar no mínimo um registro.')
                return false
            }
            let retorno = await this.$api.post(`${this.$urlBase}/manifestos/exportar_excel`, formData)
            if (retorno.status == 'success') {
                downloadBase64(retorno.data.arquivo, 'manifestos', 'xlsx')
                this.$dialog.success(retorno.message)
            } else {
                this.$dialog.error(retorno.message)
            }
        },
        async excluirSelecionados() {

            if(this.permissaoExcluirMassa === 0){
                this.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            let selecionados = []
            let formData = new FormData()
            let podeExcluir = true;

            let manifestosSelecionados = this.manifestos.filter(item => item.Manifesto.selecionado == true)

            manifestosSelecionados.forEach((item) => {
                if(item.Manifesto.situacao != 0 && item.Manifesto.situacao != 2){
                    podeExcluir = false;
                }

                selecionados.push(item.Manifesto.id)
                formData.append('manifestos[]', item.Manifesto.id)
                
            })

            if(!podeExcluir){
                this.$dialog.warning('Apenas manifestos com a situação Em aberto e Reprovada podem ser removidos.')
                return false
            }

            if (manifestosSelecionados.length == 0) {
                this.$dialog.warning('Você deve selecionar no mínimo um Manifesto para excluir.')
                return false
            }

            const confirmacao = await this.$dialog.confirm('Deseja realmente excluir os manifestos?', { icon: 'text-danger glyphicon glyphicon-trash' })

            if (confirmacao) {
                let retorno = await this.$api.post(`${this.$urlBase}/manifestos/deletar_massa/${selecionados.join(',')}`, formData)
                if (retorno.status == 'success') {
                    manifestosSelecionados.forEach((item) => {
                        const index = this.manifestos.indexOf(item)
                        this.manifestos.splice(index, 1)
                    })
                    this.$notify.success(retorno.message)
                } else {
                    this.$dialog.error(retorno.message)
                }
            }
        },
        limpaBuscaAvancada() {
            this.$router
                .push({
                    path: `${this.$route.path}`
                })
                .catch(() => {})
        },
        exportarXml() {

            if(this.permissaoExportarXml === 0){
                this.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            this.$modal.show(() => import('./ExportarXml'), 'md')
        },
        enviarWhatsapp(id) {

            if(this.permissaoCompartilharWhatsapp === 0){
                this.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            const plugin = this.$urlBase.replace('/', '')
            this.$modal.show(() => import('@/shared/components/crud/CompartilhaWhatsApp'), 'md', {
                urlApi: `${this.$urlBase}/manifestos/compartilhar_whatsapp/${id}/${plugin}`
            })
        },
        async enviarEmail(id) {

            if(this.permissaoEnviarLinkEmail === 0){
                this.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            await this.$modal.show(() => import('./EnvioEmail'), 'lg', { id: id })
            this.$refs.lista.atualiza()
        },
        async baixarXml(id) {

            if(this.permissaoBaixarXml === 0){
                this.$notify.error('Você não possui acesso a esta ação!');
                return;
            }

            const retorno = await this.$api.get(this.$urlBase + '/manifestos/baixar_xml/' + id)
            if (retorno.status == 'success') {
                downloadBase64(retorno.data.arquivo.conteudo, retorno.data.arquivo.nome, 'xml')
                this.$dialog.success(retorno.message)
            } else {
                this.$dialog.error(retorno.message)
            }
        }
    }
}
</script>

<style scoped>
.manifestos-lista .btn-group .btn {
    border-radius: 3px !important;
}
li.mais_acoes:hover,
li.mais_acoes:hover i {
    color: white !important;
}
</style>
<style>
.certificado-digital,
.certificado-digital i {
    color: black !important;
}
</style>
